module.exports = __webpack_public_path__ + "static/img/certificate_alert.392b6e1a.png";